import React, { useRef, useState } from 'react';
import { object } from 'prop-types';
import classNames from 'classnames';
import { getContext } from '@fiverr-private/fiverr_context';
import { useImpressionItem } from '@fiverr-private/impressionable';
import { translate } from '@fiverr-private/i18n-react';
import { Collapsible } from '@fiverr-private/fit';
import { Waypoint , REVIEWS } from '@fiverr-private/gig_page_waypoint_navigation';
import SafePureComponent from '../shared/SafePureComponent';
import { validateReviews } from '../../utils/mainComponentsValidator';
import { BQ_REVIEWS_TOGGLE } from '../../utils/bigQueryEvents';
import GigReviewsStandalone from './GigReviewsStandalone';
import { reviewsHeaderIsShownEvent } from './Events';
import { GIG_PAGE_REVIEWS_CLASS, REVIEWS_COPIES_PREFIX } from './constants';

import './style.scss';

const ReviewsWrapper = ({ reviews = {} }, { general, biEvents, pathfinderWrapper }) => {
    const { userId } = getContext();
    const [isExpanded, onExpand, onMinimize] = useExpanded(true);
    const [reviewsHeaderRef] = useImpressionItem(reviewsHeaderIsShownEvent(general.gigId, general.sellerId, userId));
    const observableRef = useRef(null);

    if (!validateReviews({ reviews })) {
        return null;
    }

    const onToggleCollapse = async () => {
        biEvents.sendBigQueryEvent({ eventName: BQ_REVIEWS_TOGGLE });

        return { preventToggle: false };
    };

    const props = {
        enableSearchFilter: true,
        translationUrl: pathfinderWrapper.pathfinder('gig_page_translate_ugc_api'),
        isPro: general.isPro,
        reviews,
    };

    return (
        <>
            <Waypoint source={REVIEWS} />
            <div ref={observableRef} />

            {/* This component is shown only on desktop */}
            <div className={classNames(GIG_PAGE_REVIEWS_CLASS, 'desktop-view')}>
                <div ref={reviewsHeaderRef} className="tbody-3 co-text-darker text-bold m-b-16">
                    {translate(`${REVIEWS_COPIES_PREFIX}.reviews_header`)}
                </div>
                <GigReviewsStandalone {...props} />
            </div>
            {/* This component is shown only on mobile-web */}
            <div id="collapsible-reviews-wrapper" className={classNames(GIG_PAGE_REVIEWS_CLASS, 'mobile-view')}>
                <Collapsible
                    className={classNames({ expanded: isExpanded })}
                    titleWrapperClassName="collapsible-title"
                    chevronClassName="chevron"
                    defaultExpanded
                    onExpand={onExpand}
                    onMinimize={onMinimize}
                    onToggle={onToggleCollapse}
                    title={
                        <div ref={reviewsHeaderRef} className="tbody-3 co-text-darker text-bold">
                            {translate(`${REVIEWS_COPIES_PREFIX}.reviews_header`)}
                        </div>
                    }
                >
                    <div className="p-t-16">
                        <GigReviewsStandalone {...props} />
                    </div>
                </Collapsible>
            </div>
        </>
    );
};

const useExpanded = (defaultState = false) => {
    const [isExpanded, setIsExpanded] = useState(defaultState);
    const onExpand = () => setIsExpanded(true);
    const onMinimize = () => setIsExpanded(false);

    return [isExpanded, onExpand, onMinimize];
};

ReviewsWrapper.propTypes = {
    reviews: object,
};

ReviewsWrapper.contextTypes = {
    general: object,
    rollouts: object,
    pathfinderWrapper: object,
    biEvents: object,
};

export { ReviewsWrapper };
export default SafePureComponent(ReviewsWrapper);
